import React from 'react';
import { Loader2 } from 'lucide-react';
import { Link2 } from 'lucide-react';
import { PageHeader } from '@/components/system/PageHeader';
import { SectionCard } from '@/components/system/SectionCard';
import { ConvitesIF } from '@/modules/financiamento/components/ConvitesIF';
import { useIFContratosDisponiveis, useIFInstituicoes } from '@/modules/financiamento/hooks/useIFAdminContratos';

const ConvitesIFPage: React.FC = () => {
  const { data: contratosDisponiveis = [], isLoading: loadingContratos } = useIFContratosDisponiveis();
  const { data: instituicoes = [], isLoading: loadingInst } = useIFInstituicoes();

  const isLoading = loadingContratos || loadingInst;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Convites para IFs"
        subtitle="Gerar e gerenciar convites de acesso para monitoramento de contratos"
      />
      <SectionCard title="Convites de Acesso" icon={Link2}>
        <ConvitesIF contratosDisponiveis={contratosDisponiveis} instituicoes={instituicoes} />
      </SectionCard>
    </div>
  );
};

export default ConvitesIFPage;
